import React from 'react'
import { Box, Message } from '@workwhile/ui'
import { useEditInvoiceConfigFlowContextValue } from '../context/EditInvoiceConfigFlowProvider'
import { InvoiceConfigRow } from '../../../types'
import { InvoiceConfigValuesFields } from '../../../components/InvoiceConfigValuesFields'

type EditInvoiceConfigFormProps = {
  invoiceConfig: InvoiceConfigRow
  onSubmit: () => void
}

export const EditInvoiceConfigForm = ({
  invoiceConfig,
  onSubmit,
}: EditInvoiceConfigFormProps) => {
  const {
    state: {
      mutationState: { errorMessage },
    },
  } = useEditInvoiceConfigFlowContextValue()

  const owner = invoiceConfig.company ?? invoiceConfig.companyGroup

  return (
    <Box
      as="form"
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit()
      }}
      style={{ width: '100%' }}
    >
      <Box mt={4}>{invoiceConfig.company ? 'Company' : 'Company Group'}</Box>
      <Box color="lightText">{owner ? `${owner.name} (${owner.id})` : '-'}</Box>
      <InvoiceConfigValuesFields />
      {errorMessage ? (
        <Message variant="error" mt={3} borderRadius="small">
          {errorMessage}
        </Message>
      ) : null}
    </Box>
  )
}
